import { useFieldArray, useFormContext } from 'react-hook-form';
import { Trash, CirclePlus, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Select from '@/components/form/Select';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

import { useCoachActivityLocations } from '@/data/coachActivityLocation';
const LocationsFieldArray = ({ coachActivityId }) => {
  const form = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control: form.control,
    name: 'locations'
  });

  const coachActivityLocations = useCoachActivityLocations(coachActivityId);

  if (coachActivityLocations.isLoading && !coachActivityLocations.data) {
    return null;
  }

  const {
    formState: { errors }
  } = form;
  const locationsError =
    errors?.locations?.message || errors?.locations?.root?.message;

  return (
    <div>
      <span className="text-sm font-medium">Locations</span>
      {fields.map((field, index) => (
        <div key={field.id} className="flex items-center space-x-2 mb-2">
          <div className="flex-1">
            <Select
              name={`locations.${index}`}
              label=""
              options={
                coachActivityLocations.data?.map((cal) => ({
                  value: cal.locationId,
                  label: cal.location.name
                })) || []
              }
            />
          </div>
          <div>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              onClick={() => remove(index)}
              className="flex-shrink-0"
            >
              <Trash />
            </Button>
          </div>
        </div>
      ))}
      <div className="flex justify-center mb-4">
        <Button type="button" variant="ghost" onClick={() => append('')}>
          <CirclePlus />
          &nbsp;{fields.length === 0 ? 'Add Location' : 'Add another Location'}
        </Button>
      </div>
      {locationsError && (
        <Alert variant="destructive">
          <AlertCircle size={18} />
          <AlertTitle>Error</AlertTitle>
          <AlertDescription>{locationsError}</AlertDescription>
        </Alert>
      )}
    </div>
  );
};

const LocationsFieldArrayLoader = () => {
  const form = useFormContext();
  const coachActivityId = form.watch('coachActivityId');

  if (!coachActivityId) {
    return (
      <Alert>
        <AlertCircle size={18} />
        <AlertTitle>No Activity Selected</AlertTitle>
        <AlertDescription>
          Please select an activity to add locations
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <LocationsFieldArray
      coachActivityId={coachActivityId}
      key={coachActivityId}
    />
  );
};

export default LocationsFieldArrayLoader;
